import { get, post, patch, del } from '../httpMethods';
import { ApiResponse } from '../../types/api';

export interface Designation {
  id: string;
  designationCode: string;
  name: string;
  description?: string;
  level?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDesignationPayload {
  designationCode: string;
  name: string;
  description?: string;
  level?: number;
  isActive?: boolean;
}

export const designationService = {
  getDesignations: (page = 1, limit = 20, search?: string): Promise<ApiResponse<Designation[]>> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (search) params.set('search', search);
    return get<Designation[]>(`/hr/designations?${params.toString()}`);
  },

  getAllDesignations: (): Promise<ApiResponse<Designation[]>> => {
    return get<Designation[]>('/hr/designations?limit=1000');
  },

  getActiveDesignations: (): Promise<ApiResponse<Designation[]>> => {
    return get<Designation[]>('/hr/designations?active=true');
  },

  createDesignation: (data: CreateDesignationPayload): Promise<ApiResponse<Designation>> => {
    return post<Designation>('/hr/designations', data);
  },

  updateDesignation: (id: string, data: Partial<CreateDesignationPayload>): Promise<ApiResponse<Designation>> => {
    return patch<Designation>(`/hr/designations/${id}`, data);
  },

  deleteDesignation: (id: string): Promise<ApiResponse<void>> => {
    return del<void>(`/hr/designations/${id}`);
  },
};
